import { api } from "./api";
import ShowNotifications from "../helper/ShowNotifications";

class BannerApi {
  getBanners = async (params) => {
    try {
      const response = await api.get("/banner", { params });
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      return { status: false, response: error?.response?.data || error };
    }
  };

  saveBanner = async (data) => {
    try {
      const response = await api.post("/banner", data);
      if (response.status === 200 || response.status === 201) {
        // ShowNotifications.showAlertNotification("Banner Added Successfully", true);
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Failed to add banner";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };

  deleteBanner = async (id) => {
    try {
      const response = await api.delete(`/banner/${id}`);
      if (response.status === 200 || response.status === 201) {
        // ShowNotifications.showAlertNotification("Banner Deleted Successfully", true);
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Failed to delete banner";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };

  updateBanner = async (id, data) => {
    try {
      const response = await api.put(`/banner/${id}`, data);
      if (response.status === 200 || response.status === 201) {
        // ShowNotifications.showAlertNotification("Banner Updated Successfully", true);
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Failed to update banner";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };
}

const bannerApi = new BannerApi();
export default bannerApi;

export const {
  getBanners,
  saveBanner,
  deleteBanner,
  updateBanner,
} = bannerApi;
